import { Card, Col, Form, Input, Radio, Row, Space, Typography } from "antd";
import React, { useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;
 
const PatientAddressFields = ({ getChildData, validationRules, form }) => {
  const { t } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };
 
  return (
    <>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:address_line_1")}
          name="RecipientAddress1"
          onChange={(e) => callparent(e.target.value, "RecipientAddress1")}
          rules={validationRules.RecipientAddress1}
          required
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:address_line_2")}
          name="RecipientAddress2"
          onChange={(e) => callparent(e.target.value, "RecipientAddress2")}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:city")}
          name="RecipientCity"
          onChange={(e) => callparent(e.target.value, "RecipientCity")}
          required
          rules={validationRules.city}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:state")}
          name="RecipientState"
          onChange={(e) => callparent(e.target.value, "RecipientState")}
          required
          rules={validationRules.state}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:zip_code")}
          name="RecipientZipCode"
          onChange={(e) => callparent(e.target.value, "RecipientZipCode")}
          required
          rules={validationRules.zipCode}
        >
          <Input maxLength={8} />
        </Form.Item>
      </Col>
    </>
  );
};
 
const RequesterAddressFields = ({ getChildData, validationRules, form }) => {
  const { t } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };
 
  return (
    <>
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          name="RecipientAddress1"
          label={t("patientDetailsFMLS:address_line_1")}
          onChange={(e) => callparent(e.target.value, "RecipientAddress1")}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          name="RecipientAddress2"
          onChange={(e) => callparent(e.target.value, "RecipientAddress2")}
          label={t("patientDetailsFMLS:address_line_2")}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="RecipientCity"
          label={t("patientDetailsFMLS:city")}
          onChange={(e) => callparent(e.target.value, "RecipientCity")}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="RecipientState"
          label={t("patientDetailsFMLS:state")}
          onChange={(e) => callparent(e.target.value, "RecipientState")}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="RecipientZipCode"
          label={t("patientDetailsFMLS:zip_code")}
          onChange={(e) => callparent(e.target.value, "RecipientZipCode")}
        >
          <Input maxLength={8} />
        </Form.Item>
      </Col>
    </>
  );
};
 
const Recipient = ({ getChildData, patientDetailsFMLA, form }) => {
  const { t, i18n } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };
  const isPatient = patientDetailsFMLA?.IsPatient?.toString() === "yes";
 
  useEffect(() => {
    if (!patientDetailsFMLA?.RecipientMethodOfRelease) return;
    if (patientDetailsFMLA.RecipientMethodOfRelease !== "mail") return;
    form.resetFields(["RecipientAddress1", "RecipientAddress2", "RecipientCity", "RecipientState", "RecipientZipCode"]);
    if (isPatient) {
      form.setFieldsValue({
        RecipientAddress1: patientDetailsFMLA.PAddLine1 || "",
        RecipientAddress2: patientDetailsFMLA.PAddLine2 || "",
        RecipientCity: patientDetailsFMLA.PCity || "",
        RecipientState: patientDetailsFMLA.PState || "",
        RecipientZipCode: patientDetailsFMLA.PZipCode || "",
      });
    } else {
      form.setFieldsValue({
        RecipientAddress1: patientDetailsFMLA.RequesterAddLine1 || "",
        RecipientAddress2: patientDetailsFMLA.RequesterAddLine2 || "",
        RecipientCity: patientDetailsFMLA.RequesterCity || "",
        RecipientState: patientDetailsFMLA.RequesterState || "",
        RecipientZipCode: patientDetailsFMLA.RequesterZipCode || "",
      });
    }
  }, [
    patientDetailsFMLA?.IsPatient,
    patientDetailsFMLA?.RecipientMethodOfRelease,
    form,
  ]);
 
 
 
  useEffect(() => {
    if (patientDetailsFMLA.recordsDisclose == "self") {
      let res =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PFirstName + " " + patientDetailsFMLA.PLastName
          : patientDetailsFMLA.RequesterFName +
          " " +
          patientDetailsFMLA.RequesterLName;
 
 
      let phone =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PatientPhoneNumber
          : patientDetailsFMLA.RequesterPhoneNumber;
 
      let email =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PEmail
          : patientDetailsFMLA.RequesterEmail;
 
      form.setFieldsValue({ nameorganization: res, rphone: phone, remail: email });
    }
  }, [patientDetailsFMLA.IsPatient]);
 
 
  const onChangeRadio = (e) => {
    getChildData(e.target.value, "RecipientDiscloseRecordsTo");
    if (e.target.value == "self") {
      let res =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PFirstName + " " + patientDetailsFMLA.PLastName
          : patientDetailsFMLA.RequesterFName +
          " " +
          patientDetailsFMLA.RequesterLName;
 
      let phone =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PatientPhoneNumber
          : patientDetailsFMLA.RequesterPhoneNumber;
 
      let email =
        patientDetailsFMLA.IsPatient == "yes"
          ? patientDetailsFMLA.PEmail
          : patientDetailsFMLA.RequesterEmail;
 
      form.setFieldsValue({ nameorganization: res, rphone: phone, remail: email });
    }
    else {
      form.setFieldsValue({ nameorganization: "", rphone: "", remail: "", vemail: "" });
    }
  };
 
  const validatePhone = useCallback((_, value) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("common:please_enter_a_valid_phone_number")));
  }, [t]);
 
  const validateConfirmEmail = useCallback((_, value) => {
    const email = form.getFieldValue('remail');
    if (value && value !== email) {
      return Promise.reject(new Error(t("patientDetailsFMLS:verify_email_does_not_match_with_email")));
    }
    return Promise.resolve();
  }, [form, t]);
 
  const validationRules = useMemo(() => ({
    required: [{ required: true, message: t("patientDetailsFMLS:please_choose_any_option") }],
    nameOrganization: [{ required: true, max: 110, message: t("patientDetailsFMLS:please_enter_name_or_organization") }],
    email: [{ required: true, max: 100, message: t("patientDetailsFMLS:please_enter_email") }, { type: "email", message: t("patientDetailsFMLS:please_enter_valid_email") }],
    verifyEmail: [{ required: true, max: 100, message: t("patientDetailsFMLS:please_enter_email") }, { validator: validateConfirmEmail }],
    faxNumber: [{ required: true, max: 20, message: t("patientDetailsFMLS:please_enter_fax_number") }],
    phone: [{ required: true, max: 20, message: t("patientDetailsFMLS:please_enter_phone_number") }, { validator: validatePhone }],
    RecipientAddress1: [
      {
        required: true,
        max: 150,
        message: t("patientDetailsFMLS:please_enter_address"),
      },
    ],
    city: [
      {
        required: true,
        max: 50,
        message: t("patientDetailsFMLS:please_enter_city_name"),
      },
    ],
    state: [
      {
        required: true,
        message: t("patientDetailsFMLS:please_enter_state_name"),
      },
    ],
    zipCode: [
      {
        required: true,
        max: 8,
        message: t("patientDetailsFMLS:please_enter_zip_code"),
      },
    ],
  }), [t, validatePhone, validateConfirmEmail]);
 
  return (
    <Card
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetailsFMLS:recipient_information")}
        </Title>
      }
    >
      <Form.Item
        className="font-medium"
        name="discloserecord"
        label={t("patientDetailsFMLS:who_would_you_like_to_disclose_the_form_to")}
        required
        rules={validationRules.required}
      >
        <Radio.Group onChange={onChangeRadio} >
          <Space direction="vertical" className="ms-4"
          >
            <Radio value="self" className="font-normal">
              {t("patientDetailsFMLS:self")}
            </Radio>
            <Radio value="employer/insurance" className="font-normal">
              {t("patientDetailsFMLS:employer_insurance")}
            </Radio>
            {/* <Radio value="both" className="font-normal">
              Both
            </Radio> */}
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        className="font-medium"
        label={t("patientDetailsFMLS:what_method_of_release_would_you_like")}
        required
        name="releasemethod"
        rules={validationRules.required}
      >
        <Radio.Group
          onChange={(e) => {
            callparent(e.target.value, "RecipientMethodOfRelease");
          }}
          value={patientDetailsFMLA.RecipientMethodOfRelease}
        >
          <Space direction="vertical" className="ms-4"
          >
            <Radio value="email" className="font-normal">
              {t("patientDetailsFMLS:email")}
            </Radio>
            <Radio value="fax" className="font-normal">
              {t("patientDetailsFMLS:fax")}
            </Radio>
            <Radio value="mail" className="font-normal">
              {t("patientDetailsFMLS:mail")}
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
 
      {patientDetailsFMLA.RecipientMethodOfRelease.toString() && (
        <Row gutter={[20, 0]} className="mt-4">
          <Col xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label={t("patientDetailsFMLS:name_organization")}
              onChange={(e) => callparent(e.target.value, "RecipientName")}
              required
              name="nameorganization"
              rules={validationRules.nameOrganization}
            >
              <Input maxLength={110} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}></Col>
          {patientDetailsFMLA.RecipientMethodOfRelease.toString() ===
            "email" ? (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label={t("patientDetailsFMLS:email")}
                  onChange={(e) => callparent(e.target.value, "RecipientEmail")}
                  required
                  name="remail"
                  rules={validationRules.email}
                >
                  <Input maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="vemail"
                  className="font-medium"
                  label={t("patientDetailsFMLS:verify_email")}
                  onChange={(e) =>
                    callparent(e.target.value, "RecipientVerifyEmail")
                  }
 
                  rules={validationRules.verifyEmail}
                >
                  <Input maxLength={100} />
                </Form.Item>
              </Col>
            </>
          )
          : patientDetailsFMLA.RecipientMethodOfRelease?.toString() ===
            "mail" ? (
            <>
              {isPatient ? (
                <PatientAddressFields
                  getChildData={getChildData}
                  validationRules={validationRules}
                  form={form}
                />
              ) : (
                <RequesterAddressFields
                  getChildData={getChildData}
                  validationRules={validationRules}
                  form={form}
                />
              )}
            </>
          )
          : (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label={t("patientDetailsFMLS:fax_number")}
                  onChange={(e) => callparent(e.target.value, "RecipientFax")}
                  name="faxnumber"
                  rules={validationRules.faxNumber}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label={t("patientDetailsFMLS:phone_number")}
                  onChange={(e) =>
                    callparent(e.target.value, "RecipientPhoneNumber")
                  }
                  required
                  name="phone"
                  rules={validationRules.phone}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      )}
    </Card>
  );
};
export default Recipient;
 